import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 5px;
	z-index: 1000;
`;

export const TooltipGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(12px, 12px) 2fr 1fr;
	padding: 1px 2px;
	width: 100%;
`;

export const ColorWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ColorSymbol = styled.div`
	min-width: 6px;
	max-width: 6px;
	min-height: 6px;
	max-height: 6px;
	background-color: ${({ color }) => color};
	border-radius: 50%;
`;

export const TooltipRowTitle = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-right: 16px;
	max-width: 120px;
	width: 120px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-right: 24px;
`;

export const TooltipRowValue = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	justify-content: flex-end;
	text-transform: uppercase;
`;

export const TooltipHeader = styled.div`
	font-weight: bold;
	margin-bottom: 6px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	text-align: center;
`;

export const TooltipRowPinned = styled(TooltipGrid)`
	padding-bottom: 8px;
`;

export const TooltipContainer = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
	margin: 0 auto 8px;
`;

export const TooltipItem = styled.li`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 13px;
`;

export const TooltipColor = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 4px;
	margin-right: 8px;
	background-color: ${props => props.color || 'transparent'};
`;

export const TooltipItemName = styled.span`
	text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
	margin-left: 12px;
`;
